import React from 'react';
import { Link, Image } from './../../../../components/includes/ui';

import API from './../../../../config/api';

class Banner extends React.Component {

  render(){

    const { component } = this.props;
    const { element }   = component;

    return(
      <div>
        <Link to={ element.link } target={ element.target } title={ element.title } isExrernal>
          <Image src={ `${ API.endpoint.uploads }/${ element.image }` } alt={ element.title }/>
        </Link>
      </div>
    )

  }

}

export default Banner;
